<template>
  <div class="corrup-report">
    <nav-title title="请详细描述投诉内容及证据" icon="*"></nav-title>
    <div class="message">
      <div v-if="flag" class="message-detail">{{ content }}</div>
      <van-field
        v-model="content"
        v-else
        rows="4"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="本平台不受理非舞弊、贪腐相关举报，如带来不便，敬请 谅解。 "
        show-word-limit
      />
    </div>
    <nav-title
      title="请提供相关问题的截图或图片"
      v-if="!flag || (flag && fileList.length)"
    ></nav-title>
    <div class="uploader" v-if="!flag || (flag && fileList.length)">
      <van-uploader
        max-count="6"
        :after-read="afterRead"
        @delete="handDelete"
        v-model="fileList"
        :deletable="!flag"
        :show-upload="!flag"
      >
        <div class="upload-btn">
          <img src="../../common/images/visa-change/upload.png" alt="" />
        </div>
      </van-uploader>
    </div>
    <nav-title :title="checked ? '我要实名举报' : '实名举报'">
      <div slot="info" v-if="checked">
        注：我们鼓励实名举报，承诺对个人信息及举报内容进行严格保密，
        并对实名实证举报及时调查处理。
      </div>
      <div slot="switch">
        <van-switch
          :disabled="flag"
          v-model="checked"
          @change="handswitch"
          size="24px"
          active-color="#07c160"
          inactive-color="rgba(153,153,153,.3)"
        />
      </div>
    </nav-title>
    <template v-if="checked">
      <nav-title title="举报人联系方式" icon="*"> </nav-title>
      <van-field
        v-model="name"
        label="联系人"
        :placeholder="name || '请输入联系人姓名'"
        :disabled="flag"
      />
      <van-field
        v-model="mobile"
        type="tel"
        label="联系电话"
        :disabled="flag"
        :placeholder="mobile || '留下联系方式，更快解决问题~'"
      />
    </template>
    <div class="submit-btn">
      <van-button
        type="primary"
        block
        color="#36C490"
        loading-type="spinner"
        :loading="loading"
        @click="submit"
        v-if="!flag"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
import navTitle from '../recruitment-info/components/recruit-title';
import { Button, Field, Uploader, Switch, Toast } from 'vant';
import axios from 'axios';
import OSS from 'ali-oss';

import { getUrlParams } from 'common/js/mUtils';

export default {
  components: {
    navTitle,
    [Button.name]: Button,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Switch.name]: Switch,
    [Toast.name]: Toast
  },
  data() {
    return {
      content: '',
      name: '',
      mobile: '',
      checked: false,
      fileList: [],
      ossConfig: {
        region: '',
        stsToken: '',
        accessKeyId: '',
        accessKeySecret: '',
        bucket: '',
        element: ''
      },
      body: {},
      flag: false,
      loading: false
    };
  },
  mounted() {
    // let url = config.baseURL;
    let url = 'https://api2.newhope.cn';
    axios.get(`${url}/auth/ossToken/stsToken`).then(res => {
      this.ossConfig.stsToken = res.body.SecurityToken;
      this.ossConfig.accessKeyId = res.body.AccessKeyId;
      this.ossConfig.accessKeySecret = res.body.AccessKeySecret;
      this.ossConfig.bucket = res.body.bucket;
      this.ossConfig.region = res.body.region.split('.')[0];
    });
  },

  methods: {
    handNotice() {
      this.$router.push({
        name: 'noticeReport'
      });
    },
    handswitch() {},
    submit() {
      let url = [];
      let { fileList, name, mobile, content, checked } = this;
      let { providerGuid } = getUrlParams();
      content = content.trim();
      if (!content) {
        Toast.fail('请输入投诉内容和证据');
        return;
      }
      if (checked) {
        if (!name) {
          Toast.fail('请输入联系人姓名');
          return;
        }
        if (!/^1[3456789]\d{9}$/.test(mobile)) {
          Toast.fail('请输入正确的手机格式');
          return;
        }
      }
      fileList.map(item => url.push(item.url));
      let params = {
        content,
        type: '1',
        images: url.join(','),
        name,
        mobile,
        providerGuid
      };
      this.loading = true;
      this.$api.complainSuggest(params).then(res => {
        if (res.code == '0000') {
          Toast.success('提交成功');
          this.loading = false;
          wx.miniProgram.switchTab({
            url: '/pages/complain-suggest/complain-suggest'
          });
        }
      });
    },
    ossUpload(file) {
      let that = this;
      return new Promise((resolve, reject) => {
        let client = new OSS(that.ossConfig);
        let bojName = 'dwwb/portal/project/' + new Date().getTime() + '/';
        async function putBlob() {
          try {
            let result = await client.put(bojName + file.name, file);
            resolve(result);
          } catch (e) {
            reject(e);
          }
        }
        putBlob();
      });
    },
    afterRead(files) {
      let that = this;
      if (files.content) {
        files.status = 'uploading';
        files.message = '上传中...';
        this.ossUpload(files.file)
          .then(res => {
            //debugger
            if (res.url) {
              files.status = '';
              files.message = '';
              files.url = res.url;
              files.name = files.file.name;
              let arr = [];
              that.fileList.map(item => {
                let obj = {};
                obj.name = item.name;
                obj.url = item.url;
                arr.push(obj);
              });
              //eventBus.$emit('setValue', arr, that.data)
            } else {
              files.status = 'failed';
              files.message = '上传失败';
            }
            //that.$emit('validateField', '', that.data.uuid)
          })
          .catch(() => {
            files.status = 'failed';
            files.message = '上传失败';
          });
      }
    },
    handDelete() {
      this.flag = false;
    }
  },
  created() {
    let { info, id } = getUrlParams();
    if (info) {
      this.$api.corrupReportInfo({ id }).then(res => {
        let { code, body } = res;
        if (code == '0000' && body) {
          this.content = body.content;
          this.name = body.name;
          this.mobile = body.mobile;
          this.checked = body.name ? true : false;
          let images = body.images && body.images.split(',');
          this.fileList = images.map(item => {
            return { url: item };
          });
        }
      });
      this.flag = true;
    } else {
      this.flag = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.corrup-report {
  background: #f5f5f5;
  height: 100%;
  padding-top: 20px;
  position: relative;
  .header {
    height: 88px;
    text-align: right;
    color: #36c490;
    font-size: 24px;
    line-height: 88px;
    padding-right: 34px;
  }
  .message {
    margin-bottom: 20px;
    background: #fff;
    .message-detail {
      padding: 20px 0px;
      padding-left: 32px;
      color: #9a9a9a;
      font-size: 28px;
      line-height: 1.5;
    }
  }
  .uploader {
    min-height: 244px;
    background: #fff;
    margin-bottom: 20px;
    /deep/.van-uploader__input-wrapper {
      padding: 24px 0px 20px 32px;
    }
    .upload-btn {
      min-width: 200px;
      min-height: 200px;
      img {
        width: 200px;
        height: 200px;
      }
    }
  }
  .van-cell:not(:last-child)::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0.32rem;
    border: none;
    transform: scaleY(0.5);
  }
  /deep/.van-uploader__preview-image {
    width: 200px !important;
    height: 200px !important;
    margin-top: 24px;
    margin-left: 32px;
  }
  .van-cell {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0.2rem 0.32rem;
    overflow: hidden;
    color: #323233;
    font-size: 0.28rem;
    line-height: 0.48rem;
    border-bottom: 1px solid #f5f5f5;
    background-color: #fff;
  }
  .submit-btn {
    margin: 0px 32px;
    margin-top: 88px;
    margin-bottom: 40px;
    // position: absolute;
    // bottom: 80px;
    // width: 686px;
    // left: 32px;
  }
  .report-type {
    padding-left: 32px;
    background: #f5f5f5;

    .title {
      color: #000;
      font-size: 32px;
      margin-bottom: 30px;
    }
    .item {
      margin-bottom: 35px;
      div {
        color: #999;
      }
      div:nth-child(1) {
        color: #000;
        font-size: 26px;
        margin-bottom: 20px;
      }
      div:not(:nth-child(1)) {
        line-height: 2;
      }
    }
  }
}
</style>
